// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"aebfc4e5","488":"7af7e02c","732":"ac37a3f4","977":"2bb1d212"}[chunkId] + ".chunk.js";
};